<div
  class="track-item theme-beats__beat-bg theme-beats__beat-bg-hover"
  [ngClass]="{
    'track-item--active  theme-beats__beat-bg-active': track?.id === player.currentTrack?.id,
    'track-item--unavailable': isTrackInCart && !track?.isOK,
    'track-item--promo': track?.isPromo
  }"
  (click)="playBeat($event, track)"
>
  <!-- Play button shown on hover  -->
  <div
    class="common-track-cover__play-icon common-track-cover__play-icon--in-catalog"
    [ngClass]="{ 'common-hide-play-icon': track?.id === player.currentTrack?.id }"
  >
    <button class="common-play-pause-btn--in-catalog btv-icon-play" aria-label="play"></button>
  </div>

  <!-- Active track -->
  @if (player?.currentTrack?.id === track?.id && player.status === PlayStatus.Playing) {
    <div class="common-track-cover__pause-icon common-track-cover__pause-icon--in-catalog">
      <button class="common-play-pause-btn--in-catalog btv-icon-pause" aria-label="pause"></button>
    </div>
  }

  <!-- Track description (image, beat, beatmaker, styles) -->
  <div class="track-item__track-descr-box">
    <bmcore-track-descr
      [ordinalNumber]="ordinalNumber"
      [currencySign]="currencySign"
      [isPromoTrack]="track.isPromo"
      [isTrackInCart]="isTrackInCart"
      [fixedBeat]="track"
      [appType]="appType"
      [showVerificationIcon]="showVerificationIcon"
      [verificationIconSize]="12"
    >
    </bmcore-track-descr>
  </div>

  <!-- Track controls (download, fav, share, buy) -->
  @if (!isTrackInCart) {
    <div class="track-item__controls">
      <div class="track-item__download-btn-container" [ngClass]="{ hide: isTopSeller }">
        @if (track.type !== 'free-beat') {
          <bmcore-download-btn
            [demoDownloading]="track.demoDownloading"
            [downloadMp3Url]="track.mp3"
            [parentComponent]="'track-item'"
            [trackId]="track.id"
          >
          </bmcore-download-btn>
        }
      </div>
      @if (isShowFavBtn) {
        <div class="track-item__fav-btn-container" [ngClass]="{ hide: isTopSeller }">
          <bmcore-fav-btn [track]="track"></bmcore-fav-btn>
        </div>
      }
      @if (appType !== 'WIDGET') {
        <div class="track-item__share-btn-container" [ngClass]="{ hide: isTopSeller }">
          <bmcore-share-btn [track]="track" [parentComponent]="'track-item'"></bmcore-share-btn>
        </div>
      }
      @if (track.type !== 'free-beat') {
        <bmcore-button
          class="track-item__desktop-mode"
          [ngClass]="{ hide: isTopSeller }"
          [themeBtnClass]="isCurrentTrackInCart ? 'theme-btn__beatsBlock-inCart' : 'theme-btn__beatsBlock-buy'"
          [themeIconClass]="isCurrentTrackInCart ? 'theme-icon__beatsBlock-inCart' : 'theme-icon__beatsBlock-buy'"
          title="{{ isCurrentTrackInCart ? lg.button.goToCart : lg.button.buy }}"
          icon="btv-icon-cart"
          [styleName]="isCurrentTrackInCart ? 'in cart' : 'track'"
          [routerPath]="isCurrentTrackInCart && checkoutPage"
          (clickHandler)="!isCurrentTrackInCart && wantToAddBeat($event, track.id)"
        >
        </bmcore-button>
        <!-- Shown on screens smaller than 576 px -->
        <bmcore-button
          class="track-item__mob-mode"
          [ngClass]="{ 'track-item__dots--active': isTopSeller }"
          [themeBtnClass]="isCurrentTrackInCart ? 'theme-btn__beatsBlock-inCart' : 'theme-btn__beatsBlock-buy'"
          [themeIconClass]="isCurrentTrackInCart ? 'theme-icon__beatsBlock-inCart' : 'theme-icon__beatsBlock-buy'"
          icon="btv-icon-cart"
          mobMode="true"
          [styleName]="isCurrentTrackInCart ? 'in cart' : 'track'"
          [routerPath]="isCurrentTrackInCart && checkoutPage"
          (clickHandler)="!isCurrentTrackInCart && wantToAddBeat($event, track.id)"
        >
        </bmcore-button>
      } @else {
        <bmcore-button
          class="track-item__desktop-mode"
          [ngClass]="{ hide: isTopSeller }"
          [themeBtnClass]="'theme-btn__beatsBlock-buy'"
          [themeIconClass]="'theme-icon__beatsBlock-buy'"
          [title]="lg.button.download"
          icon="btv-icon-download"
          [styleName]="'track'"
          [routerLink]="['/free-beat', track.id]"
        >
        </bmcore-button>
        <!-- Shown on screens smaller than 576 px -->
        <bmcore-button
          class="track-item__mob-mode"
          [ngClass]="{ 'track-item__dots--active': isTopSeller }"
          [themeBtnClass]="'theme-btn__beatsBlock-buy'"
          [themeIconClass]="isCurrentTrackInCart ? 'theme-icon__beatsBlock-inCart' : 'theme-icon__beatsBlock-buy'"
          icon="btv-icon-download"
          mobMode="true"
          [styleName]="'track'"
          [routerLink]="['/free-beat', track.id]"
        >
        </bmcore-button>
      }
      <!-- Shown on screens smaller than 767 px -->
      <div class="track-item__dots" [ngClass]="{ 'track-item__dots--active': isTopSeller }">
        <bmcore-track-mob-controls
          [track]="track"
          [isShowFavBtn]="isShowFavBtn"
          [showDownloadBtn]="track.type !== 'free-beat'"
          [showShareBtn]="appType !== 'WIDGET'"
        ></bmcore-track-mob-controls>
      </div>
    </div>
  }

  <!-- Track in cart section: price, edit license, delete track -->
  @if (isTrackInCart) {
    <bmcore-track-section-in-cart class="track-item__section-in-cart" [track]="track" [parentComponent]="'track-item'">
    </bmcore-track-section-in-cart>
  }
</div>
<div class="line theme-beats__beatDividerLine"></div>
<!-- Unavailable beat -->
@if (isTrackInCart) {
  @if (!track.isOK) {
    <div class="unavailable">
      <span class="btv-icon-info"></span>
      <p class="unavailable__text">{{ track?.message }}</p>
    </div>
  }
}
